<script setup>
/**
 * M3 divider line; horizontal or vertical with optional inset padding.
 *
 * @status recommended
 * @group layout
 * @useWhen Visually separating sections of content or adjacent list items
 * @see https://quasar.dev/vue-components/separator Quasar q-separator API
 */
defineOptions({ name: 'HrDivider' });

const props = defineProps({
  /** Renders as a vertical line (default is horizontal). */
  vertical: {
    type: Boolean,
    default: false,
  },
  /**
   * Adds inset padding so the divider doesn't touch container edges.
   * Horizontal: left inset (M3 inset divider).
   * Vertical: top/bottom inset (M3 toolbar group separator).
   */
  inset: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <q-separator
    v-bind="$attrs"
    :vertical="props.vertical"
    :inset="props.inset"
    class="hr-divider"
  />
</template>

<style lang="scss" scoped>
.hr-divider {
  background-color: var(--app-outline-variant);
}
</style>
